import React from "react"

export default function NotFound() {
  if (typeof window !== "undefined") {
    window.location = "https://www.udacity.com/"
  }

  return null
}
